const connectToggles = document.querySelectorAll('.connect-sec__toggle'),
      connectForms = document.querySelectorAll('.connect-sec__form');

if(connectToggles.length) {
  connectToggles[0].classList.add('active');
  connectForms[0].classList.add('active');

  connectToggles?.forEach(((toggle, i) => {
    toggle.addEventListener('click', () => {
      connectToggles.forEach(t => t.classList.remove('active'))
      toggle.classList.add('active');

      connectForms.forEach(f => f.classList.remove('active'));
      connectForms[i].classList.add('active');
    })
  }))
}